$('.hiddenSearchButton').on('click', function(e) {
    const target = $(e.currentTarget)
    let $input = target.siblings('input');

    // Toggle width expansion
    if ($input.width() === 32) {
        $input.css('width', '200px');
        $input.css('padding', '');
        $input.css('padding-left', '26px');
        $input.css('border', '');
        $input.css('color', '');
        $input.focus();
    } else {
        $input.css('width', '0');
        $input.css('padding', '0');
        $input.css('border', '0');
        $input.css('color', 'transparent');
    }
});
